import { StatsigClient } from '@statsig/js-client';

export const LOOM_LAND_EXPOSURE_FLUSH_TIMEOUT_MS = 2_000;

/** Keep the document alive until the SDK reports a successful exposure request. */
export const flushLoomLandExposure = async (
	experimentName: string,
	fireExposure: () => void,
): Promise<boolean> => {
	let timeout: ReturnType<typeof setTimeout> | undefined;
	let unsubscribe: (() => void) | undefined;
	try {
		const sdkKey = window.featureGateBootstrapValues?.clientSdkKey;
		if (!sdkKey) {
			return false;
		}
		// Use WAC's key explicitly: other clients may be initialized on the page.
		const client = StatsigClient.instance(sdkKey);
		if (client.loadingStatus !== 'Ready') {
			return false;
		}
		let exposureFlushed = false;
		const onFlushed = ({ events }: { events: Record<string, unknown>[] }) => {
			exposureFlushed ||= events.some((event) => {
				const metadata = event['metadata'];
				return (
					event['eventName'] === 'statsig::config_exposure' &&
					typeof metadata === 'object' &&
					metadata !== null &&
					'config' in metadata &&
					metadata.config === experimentName
				);
			});
		};
		client.on('logs_flushed', onFlushed);
		unsubscribe = () => client.off('logs_flushed', onFlushed);
		fireExposure();
		return await Promise.race([
			// flush() alone can resolve after an HTTP failure. Only logs_flushed
			// confirms a successful transport result; ingestion is verified separately.
			client.flush().then(() => exposureFlushed),
			new Promise<boolean>((resolve) => {
				timeout = setTimeout(() => resolve(false), LOOM_LAND_EXPOSURE_FLUSH_TIMEOUT_MS);
			}),
		]);
	} catch {
		return false;
	} finally {
		clearTimeout(timeout);
		unsubscribe?.();
	}
};
